const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

module.exports = createReactClass({
	displayName: "OdometerDigit",

	propTypes: {
		digit: PT.number.isRequired,
	},

	getInitialState: function() {
		return {
			currDigit: this.props.digit,
			translate: this.props.digit,
		};
	},

	statics: {
		getDerivedStateFromProps: function(props, state) {
			const digitIncr = (props.digit - state.currDigit + 10) % 10;
			return {
				currDigit: props.digit,
				translate: state.translate + digitIncr,
			};
		},
	},

	render: function() {
		const digits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
		const animTranslate = -5 * this.state.translate;
		const listTranslate = 50 * (Math.floor(this.state.translate / 10) - 1);

		const animStyle = {
			position: "relative",
			transform: "translateY(" + animTranslate + "%)",
			transition: "transform 500ms linear",
		};
		const listStyle = {
			position: "relative",
			transform: "translateY(" + listTranslate + "%)",
		};
		const ds = digits.map((d, i) => <div key={i}>{d}</div>);
		return (
			<div style={animStyle}>
				<div style={listStyle}>{ds}</div>
			</div>
		);
	},
});
